import {
  useMemo,
} from 'react';
import {
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  getApiVoiceAssistantGetContextFromPopulate,
  getApiVoiceAssistantGetQueryAnswer,
  getApiVoiceAssistantGetSession,
} from 'endpoints';
import isNil from 'lodash/isNil';
import {
  ChatMessageContent,
} from 'dtos';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  useGetUsers,
} from 'pages/Dashboard/hooks/providers';
import {
  getDisplayName,
} from 'pages/Dashboard/utils/helper';

export function useUserFullName(userId: number | null | undefined): string | null {
  const { data: users = [] } = useGetUsers({ onlyDoctors: false });

  const user = useMemo(
    () => users.find((user) => user.userId === userId),
    [users, userId],
  );

  return getDisplayName(user?.formattedNames, undefined) ?? null;
}

export function useGetAISessionInfo(id?: string | null): UseQueryResult<any, Error> {
  return useQuery<any, Error>({
    queryKey: ['ai-session-info', id],
    queryFn: async () => {
      const response = await getApiVoiceAssistantGetSession();
      return response;
    },
    enabled: !isNil(id),
  });
}

export function useGetAISessionQueryAnswer(
  query?: string,
  sessionId?: string,
): UseQueryResult< ChatMessageContent, Error> {
  return useQuery<ChatMessageContent, Error>({
    queryKey: ['ai-session-query-answer', query],
    queryFn: async () => {
      const response = await getApiVoiceAssistantGetQueryAnswer({
        query,
        sessionId,
      });
      return response;
    },
    enabled: notEmptyString(query),
  });
}

export function useGetAISessionQueryContext(
  query?: string,
  sessionId?: string,
): UseQueryResult< string, Error> {
  return useQuery<string, Error>({
    queryKey: ['ai-session-query-context', query],
    queryFn: async () => {
      const response = await getApiVoiceAssistantGetContextFromPopulate({
        query,
        sessionId,
      });
      return response;
    },
    enabled: notEmptyString(query),
  });
}
